// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3DdFH","Label":"Checkbox_Label__3XusL","InputElement":"Checkbox_InputElement__YK6mm","Invalid":"Checkbox_Invalid__92gM6"};